var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"app-returned-menu"},[(_vm.returnedStaff)?_c('a',{staticClass:"mr-2 red--text",attrs:{"href":"/admin/#/lids/staff"}},[_vm._v(_vm._s(_vm.returnedStaff))]):_vm._e(),_vm._v(" "),(_vm.returnedTourist)?_c('a',{staticClass:"mr-2 red--text",attrs:{"href":"/admin/#/lids/tourist"}},[_vm._v(_vm._s(_vm.returnedTourist))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }